export default function AffiliateEbay({ title, link }) {
  return (
    <a
      href={link}
      className="affiliate-btn ebay-btn"
      target="_blank"
      rel="noopener noreferrer nofollow"
    >
      {title}
    </a>
  );
}
